/*
Usage:
constructor () {
  this.lockId = Semafor.getLockId()
  this.semafor = new Semafor()
}

async myHeavyFunc () {
  // if has lock
  if (this.semafor.hasLock() === true) {
    // wait for free thread
    await this.semafor.waitForUnlock(this.lockId)
  }

  // lock thread
  this.semafor.lock(this.lockId)
  for (let i = 0; i < 99999999999; i++) {
    // too hard work
  }

  // unlock thread
  this.semafor.unlock(this.lockId)
}
*/

const queue = {}

export default class Semafor {
  queue = {}
  threads = 1

  /**
   * @param threads {Number}
   * @param queueLink {Object}
   */
  constructor(threads, queueLink) {
    this.threads = threads || this.threads
    this.queue = queueLink || queue
  }

  /**
   * @returns {string}
   */
  static getLockId() {
    return `${+new Date()}_${Math.random()}`
  }

  /**
   * @returns {boolean}
   */
  hasLock() {
    let lockCount = 0
    for (let id in this.queue) {
      if (this.queue[id].locked === true) {
        lockCount++
      }
    }
    return lockCount >= this.threads
  }

  lock(id) {
    this.printLn('locked', id)
    this.createEmptyIfNotExit(id)
    this.queue[id].locked = true
  }

  unlock(id) {
    this.printLn('unlocked', id)
    if (this.queue[id]) {
      this.queue[id].locked = false
      delete this.queue[id]
    }
    this.resolveNextFree()
  }

  onlyUnlock(id) {
    this.printLn('only unlocked', id)
    if (this.queue[id]) {
      this.queue[id].locked = false
      delete this.queue[id]
    }
  }

  resolveNextFree() {
    this.printLn('resolveNextFree', this.queue)
    let freeCount = 0
    for (let id in this.queue) {
      if (
        this.queue[id].locked === false &&
        typeof this.queue[id].locked !== 'undefined'
      ) {
        this.printLn('resolve now', this.queue[id].resolve)
        this.queue[id].resolve(true)
        freeCount++
        if (freeCount >= this.threads) {
          break
        }
      }
    }
  }

  createEmptyIfNotExit(id) {
    if (!this.queue[id]) {
      this.queue[id] = {
        locked: false,
        resolve() {
          return true
        },
      }
    }
  }

  /**
   * @param id
   * @returns {Promise<boolean>}
   */
  waitForUnlock(id) {
    this.createEmptyIfNotExit(id)
    return new Promise((resolve) => {
      this.queue[id].resolve = resolve
    })
  }

  printLn(...args) {
    console.warn(...args, this.queue)
  }
}
